import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=020fdda7&lang=pug&"
import script from "./BasicHeader.vue?vue&type=script&lang=ts&"
export * from "./BasicHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports